import React from "react";
import {
  Car, Waves, ShowerHead, Flame, WashingMachine, Shirt, Wind, Wifi, Tv, Users, Ban,
  ChefHat, Utensils, CookingPot, Sun, Droplets, ShieldCheck, BusFront, CarFront, Coffee,
  Bath, BedDouble, Dumbbell, TreePine, MountainSnow, Sparkles, Music, Baby, Dog, ParkingCircle,
  Key, Phone, MapPin, Star, Heart, Gift, Wine, Camera, Snowflake, Fan, Lightbulb, Lock, Leaf,
  Bike, Plane, Refrigerator, Microwave, Speaker, Gamepad2, Check,
  Fish, Target, Dices, Binoculars, Sailboat,
} from "lucide-react";

export const FACILITY_ICONS = {
  Car, Waves, ShowerHead, Flame, WashingMachine, Shirt, Wind, Wifi, Tv, Users, Ban,
  ChefHat, Utensils, CookingPot, Sun, Droplets, ShieldCheck, BusFront, CarFront, Coffee,
  Bath, BedDouble, Dumbbell, TreePine, MountainSnow, Sparkles, Music, Baby, Dog, ParkingCircle,
  Key, Phone, MapPin, Star, Heart, Gift, Wine, Camera, Snowflake, Fan, Lightbulb, Lock, Leaf,
  Bike, Plane, Refrigerator, Microwave, Speaker, Gamepad2, Check,
  Fish, Target, Dices, Binoculars, Sailboat,
};

export const FACILITY_ICON_NAMES = Object.keys(FACILITY_ICONS);

export const FacilityIcon = ({ name, ...props }) => {
  const C = FACILITY_ICONS[name] || Check;
  return <C {...props} />;
};
